// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-filters[data-v-5581217d]{width:150px;height:100%;margin-left:20px}@media (max-width:768px){.select-filters[data-v-5581217d]{margin-left:unset}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
